import { gql } from '@apollo/client'

export const GET_INVOICED_ORDERS = gql`
  query GET_INVOICED_ORDERS(
    $searchTerm: String
    $orderBy: [OrderOrderByWithRelationInput!]
    $take: Int
    $skip: Int
  ) {
    findManyOrderCount(
      where: {
        invoice_code: { not: null }
        OR: [
          {
            purchased_by: {
              is: { name: { mode: insensitive, contains: $searchTerm } }
            }
          }
          {
            purchased_by: {
              is: { surname: { mode: insensitive, contains: $searchTerm } }
            }
          }
          { order_code: { mode: insensitive, contains: $searchTerm } }
          { order_external_code: { mode: insensitive, contains: $searchTerm } }
          { company_name: { mode: insensitive, contains: $searchTerm } }
          { invoice_code: { mode: insensitive, contains: $searchTerm } }
        ]
      }
    )
    findManyOrder(
      orderBy: $orderBy
      where: {
        invoice_code: { not: null }
        OR: [
          {
            purchased_by: {
              is: { name: { mode: insensitive, contains: $searchTerm } }
            }
          }
          {
            purchased_by: {
              is: { surname: { mode: insensitive, contains: $searchTerm } }
            }
          }
          { order_code: { mode: insensitive, contains: $searchTerm } }
          { order_external_code: { mode: insensitive, contains: $searchTerm } }
          { company_name: { mode: insensitive, contains: $searchTerm } }
          { invoice_code: { mode: insensitive, contains: $searchTerm } }
        ]
      }
      take: $take
      skip: $skip
    ) {
      id
      createdAt
      order_status
      order_code
      order_external_code
      invoice_code
      invoice_assigned_at
      invoice_pdf_url
      company_name
      purchased_by {
        id
        name
        surname
      }
    }
  }
`
